import type { SerialPortOption } from '@/features/serial/serialManager';

const COM_PORT_PATTERN = /\((?<port>COM\d+)\)\s*$/i;

function resolveDirectPortPath(
  portId: string,
  availablePorts: SerialPortOption[],
): string | null {
  if (!portId) {
    return null;
  }

  if (portId.startsWith('local:') || portId.startsWith('helper:')) {
    return portId.slice(portId.indexOf(':') + 1);
  }

  const selected = availablePorts.find((entry) => entry.id === portId);
  if (!selected) {
    return null;
  }

  const labelMatch = selected.label.match(COM_PORT_PATTERN);
  if (labelMatch?.groups?.port) {
    return labelMatch.groups.port.toUpperCase();
  }

  if (selected.id.startsWith('local:') || selected.id.startsWith('helper:')) {
    return selected.id.slice(selected.id.indexOf(':') + 1);
  }

  if (/^COM\d+$/i.test(selected.label)) {
    return selected.label.toUpperCase();
  }

  return null;
}

export function resolveUploadPortPath(
  portId: string,
  availablePorts: SerialPortOption[],
): string | null {
  const direct = resolveDirectPortPath(portId, availablePorts);
  if (direct) {
    return direct;
  }

  // After Web Serial connect, the dropdown id becomes webserial-* which has no COM name.
  const comEntries = availablePorts.filter(
    (entry) => entry.source === 'local' || entry.source === 'helper',
  );

  for (const entry of comEntries) {
    const path = resolveDirectPortPath(entry.id, availablePorts);
    if (path) {
      return path;
    }
  }

  return null;
}

export function getSelectedComPortLabel(portPath: string | null): string | null {
  return portPath?.toUpperCase() ?? null;
}
